module.exports = __webpack_public_path__ + "img/access-control.fcb5f1e0.png";